import { MiniMemory } from './mini-memory';
customElements.define('mini-memory', MiniMemory);
